import React from 'react';
import { CTAButton, CHECKOUT_URL } from './CTAButton';
import { TodayOfferCard } from './TodayOfferCard';
import { BuildCardCarousel } from './BuildCardCarousel';
export function CardPreview() {
  return <div className="mt-6 sm:mt-8" data-id="element-53" data-mp="2iskmjoz1ji12">
      <div className="mb-8 flex flex-col items-center text-center" data-id="element-54" data-mp="2irjcnntrh1kx">
        <span className="text-xs font-bold uppercase tracking-widest text-blue-deep" data-id="element-55" data-mp="2du9hrsnlrxpp">
          A look inside a build card
        </span>
        <h3 className="mt-2 font-serif-display text-2xl font-bold leading-tight text-navy sm:text-3xl" data-id="element-56" data-mp="1q1j7dnvclmhj">
          One card. <span className="text-blue" data-id="element-57" data-mp="1ztgikumcweg9">One clear next adventure.</span>
        </h3>
        <p className="mt-3 text-sm leading-relaxed text-navy/75 sm:text-base" data-id="element-58" data-mp="1zvjhk45hlhx4">
          Every build card tells you what to gather, how long it takes, the difficulty, whether
          adult help is needed, how to build it, why it works, and what to try next.
        </p>

        <BuildCardCarousel data-id="element-59" data-mp="12d9pgx199ivo" />
      </div>

      <CTAButton label="GET THE FULL INVENTOR LAB" href={CHECKOUT_URL} external data-id="element-60" data-mp="12c89qf9ao87m" />
      <TodayOfferCard data-id="element-61" data-mp="npvy26g32ay" />
      <div className="mt-4 rounded-xl border border-blue/15 bg-blueprint px-4 py-3 text-center" data-id="element-62" data-mp="4re2chjcbrum">
        <p className="text-sm font-bold text-blue-deep" data-id="element-63" data-mp="9i45rp87hkmo">🔒 Secure checkout</p>
        <p className="mt-1 text-xs leading-relaxed text-navy/70 sm:text-sm" data-id="element-64" data-mp="9k7735et706p">
          All major credit and debit cards accepted. Your $27 payment is processed securely.
        </p>
      </div>
    </div>;
}